import React, { useEffect, useState } from "react";

export interface CheckHOCProps {
  isChecked?: boolean;
  onChange?: (v: React.ChangeEvent<HTMLInputElement>) => void;
  id?: string;
  label?: string;
  description?: string;
  isYesNo?: boolean;
  disabled?: boolean;
  containerStyle?: React.CSSProperties;
  strokeColor?: string;
}

const withCheckHOC = (OriginalComponent: React.FunctionComponent<any>) => {
  const NewComponent = (props: CheckHOCProps) => {
    const { isChecked, onChange, ...propsToFwd } = props;
    const [isCbChecked, setIsCbCheck] = useState(isChecked ?? false);
    useEffect(() => {
      if (typeof isChecked === "boolean") {
        setIsCbCheck(isChecked);
      }
    }, [isChecked]);
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      if (onChange instanceof Function) {
        onChange(e);
      } else setIsCbCheck(e.target.checked);
    };

    return (
      <OriginalComponent
        isChecked={isCbChecked}
        handleChange={handleChange}
        {...propsToFwd}
      />
    );
  };
  return NewComponent;
};

export default withCheckHOC;
